import { DropdownOption } from '../models/dropdown-option.model';

export const getFilterFromDropdownOptions = function(dropdownOptions: DropdownOption[], filterName: string):string[] {
  const filterBy: string[] = [];
  const currentFilterOptions = dropdownOptions.filter((option) => option.selected === true);
  if (currentFilterOptions && currentFilterOptions.length) {
    const filters = currentFilterOptions.filter((filterOption) => filterOption.name === filterName);
    filters.forEach((filter, index) => {
      // change boolean values to 0/1 to match stored DB values and ensure correct behaviour
      if (filter.value === true) {
        filter.value = 1;
      } else if (filter.value === false) {
        filter.value = 0;
      }
      const filterSuffix = index === 0 ? '' : '$or:';
      if (filter.value !== undefined) {
        filterBy.push(`${filterSuffix}${filter.operator}:${filter.value}`);
      } else {
        filterBy.push(`${filterSuffix}${filter.operator}`);
      }
    });
  }
  return filterBy;
}
